import TrainingPlan from './TrainingPlan';
export default TrainingPlan;
